import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Input } from "@digital-services/ui";
import { isNotEmpty, maxLength, useInput } from "@ds-cps/ui";

interface Props {
  label: string;
  value: string | undefined;
  placeholder: string;
  onInputChange?: (newValue: string, isValid: boolean) => void;
}

export const DisplayNameSimpleField: FunctionComponent<Props> = props => {
  const { label, value, placeholder, onInputChange } = props;

  const { t } = useTranslation();

  const {
    value: displayName,
    isValid,
    errorMessage,
    valueChangeHandler
  } = useInput(
    [
      maxLength(256, () =>
        t("validation.string.max-length", {
          fieldName: label,
          maxLength: 256
        })
      ),
      isNotEmpty(() => t("validation.string.not-empty", { fieldName: label }))
    ],
    value
  );

  return (
    <Input
      data-testid="display-name-simple"
      id="displayNameSimple"
      type="text"
      label={label}
      placeholder={placeholder}
      error={!isValid}
      helperText={isValid ? undefined : errorMessage}
      value={displayName}
      onChange={event => {
        const { value, isValid } = valueChangeHandler(event.target.value);
        if (onInputChange) onInputChange(value, isValid);
      }}
    />
  );
};
